import { application } from "./application"
import ApexChartController from "./apex_chart_controller"
import ChoicePanelsController from "./choice_panels_controller"
import DateSanityCheckController from "./date_sanity_check_controller"
import DealMapController from "./deal_map_controller"
import FddBatchController from "./fdd_batch_controller"
import HelloController from "./hello_controller"
import HsBrandMappingController from "./hs_brand_mapping_controller"
import HubspotBrandOnboardingToolController from "./hubspot_brand_onboarding_tool_controller"
import IntroAvailabilityController from "./intro_availability_controller"
import ModalAutofocusController from "./modal_autofocus_controller"
import PlaceAutocompleteController from "./place_autocomplete_controller"
import PlaceAutocompleteValidationController from "./place_autocomplete_validation_controller"
import PlaceTokenController from "./place_token_controller"
import ProjectionBreakdownController from "./projection_breakdown_controller"
import SeeThroughStatsController from "./see_through_stats_controller"
import SelectTokenController from "./select_token_controller"
import ShowMoreController from "./show_more_controller"
import TrixEmailController from "./trix_email_controller"
import TerritoryCheckResponseController from "./territory_check_response_controller"
import TerritoryMapController from "./territory_map_controller"
import TypedConfirmationController from "./typed_confirmation_controller"

application.register("apex-chart", ApexChartController)
application.register("date-sanity-check", DateSanityCheckController)
application.register("deal-map", DealMapController)
application.register("hello", HelloController)
application.register("hubspot-brand-onboarding-tool", HubspotBrandOnboardingToolController)
application.register("intro-availability", IntroAvailabilityController)
application.register("modal-autofocus", ModalAutofocusController)
application.register("place-autocomplete", PlaceAutocompleteController)
application.register("place-autocomplete-validation", PlaceAutocompleteValidationController)
application.register("place-token", PlaceTokenController)
application.register("projection-breakdown", ProjectionBreakdownController)
application.register("see-through-stats", SeeThroughStatsController)
application.register("select-token", SelectTokenController)
application.register("show-more", ShowMoreController)
application.register("trix-email", TrixEmailController)
application.register("territory-check-response", TerritoryCheckResponseController)
application.register("territory-map", TerritoryMapController)
application.register("typed-confirmation", TypedConfirmationController)
application.register("fdd-batch", FddBatchController)
application.register("choice-panels", ChoicePanelsController)
application.register("hs-brand-mapping", HsBrandMappingController)
